export default "__VITE_PUBLIC_ASSET__b2fd78d4__"